import React from 'react';

function Footer() {
  return (
    <footer className="py-5 bg-dark">
      <div className="container"><p className="m-0 text-center text-white">Copyright &copy; Ntrepid Design 2025</p></div>
    </footer>
  );
}

export default Footer;
